import React, { useState, useEffect } from 'react';
import RSVPForm from './components/RSVPForm';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import Footer from './components/Footer';
import WeddingInvitation from './components/CurtainAnimation';
import PhotoUploadPage from './pages/PhotoUploadPage';
import GalleryPage from './pages/GalleryPage';
import { isAdminAuthenticated, extendAdminSession } from './utils/auth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const handleRSVPSuccess = () => {
    // This function is now handled directly in the RSVPForm component
    // by showing the appropriate confirmation page
  };

  // URL parameter routing
  const urlParams = new URLSearchParams(window.location.search);
  const isAdminMode = urlParams.get('admin') === 'true';
  const isPhotoUploadMode = urlParams.get('photoUpload') === 'true' || window.location.pathname === '/photos';
  const isGalleryMode = urlParams.get('gallery') === 'true' || window.location.pathname === '/gallery';

  // Check authentication status on component mount and when admin mode is accessed
  useEffect(() => {
    if (isAdminMode) {
      const authenticated = isAdminAuthenticated();
      setIsAuthenticated(authenticated);
      
      // Extend session if authenticated
      if (authenticated) {
        extendAdminSession();
      }
    }
    setIsCheckingAuth(false);
  }, [isAdminMode]);

  // Handle successful login
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };
  
  // Show loading state while checking authentication
  if (isCheckingAuth && isAdminMode) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sage-50 to-dusty-rose-50">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-sage-200 border-t-sage-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Render photo upload page
  if (isPhotoUploadMode) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1">
          <PhotoUploadPage />
        </div>
        <Footer />
      </div>
    );
  }

  // Render gallery page
  if (isGalleryMode) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1">
          <GalleryPage />
        </div>
        <Footer />
      </div>
    );
  }

  // Render admin pages without animation wrapper
  if (isAdminMode) {
    return (
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-sage-50 to-dusty-rose-50">
        <div className="flex-1">
          {isAuthenticated ? (
            <AdminDashboard onBack={() => {
              // Remove admin parameter from URL and reload
              const url = new URL(window.location.href);
              url.searchParams.delete('admin');
              window.location.href = url.toString();
            }} />
          ) : (
            <AdminLogin onLoginSuccess={handleLoginSuccess} />
          )}
        </div>
        <Footer />
      </div>
    );
  }

  // Render regular RSVP pages with animation wrapper
  return (
    <WeddingInvitation>
      {(selectedLanguage) => (
        <div className="min-h-screen flex flex-col">
          {/* Main Content */}
          <div className="flex-1">
            <RSVPForm onSubmitSuccess={handleRSVPSuccess} selectedLanguage={selectedLanguage} />
          </div>

          {/* Footer */}
          <Footer />

          {/* Confirmation is now handled directly in the RSVPForm component */}
        </div>
      )}
    </WeddingInvitation>
  );
}

export default App;
